import React from 'react'

const TeamGoals = () => {
  return (
    <div>TeamGoals</div>
  )
}

export default TeamGoals